export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6786.6e7cac9c.jpg";